"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FolderHeading = void 0;
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var FolderHeading = (0, mobx_react_1.observer)(function (_a) {
    var text = _a.text, actions = _a.actions;
    return (react_1.default.createElement("div", { className: "content-sidebar-folder-heading space-stack-s" },
        react_1.default.createElement("div", { className: "folder-heading__text" }, text),
        actions));
});
exports.FolderHeading = FolderHeading;
